import AdminCreate from "../../components/admin/Create";

export default function CreatePage() {
  return (
    <div className="min-h-screen p-6 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <AdminCreate />
      </div>
    </div>
  );
}
